import { render, staticRenderFns } from "./vedio.vue?vue&type=template&id=c4d8467c&scoped=true"
import script from "./vedio.vue?vue&type=script&lang=js"
export * from "./vedio.vue?vue&type=script&lang=js"
import style0 from "./vedio.vue?vue&type=style&index=0&id=c4d8467c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d8467c",
  null
  
)

export default component.exports